<wiz-h-divider width="100%" height="100%" gap="0">
  <!-- panneau gauche -->
  <wiz-vgroup width="344px" height="100%" #vgGrid>
    <multi-display #multiDisp width="100%" height="100%" [config]="multiDisplayConfig">
      <wiz-hgroup>

      </wiz-hgroup>
      <wiz-hgroup target="icons" padding="3px">
        <wiz-icon [wizTooltip]="'$.common.export.$'" class="image-purple" (click)="doAct('export')">download</wiz-icon>
        <wiz-icon [wizTooltip]="'$.common.import.$'" class="image-purple" (click)="doAct('import')">upload</wiz-icon>
      </wiz-hgroup>

      <wiz-hgroup verticalAlign="center" target="title">
        <wiz-label class="titleLabel" [wizLabel]="'$.users.$'" [wizTextBehavior]="'truncate'" width="100%"></wiz-label>
      </wiz-hgroup>
    </multi-display>
  </wiz-vgroup>
  <!-- zone détail -->
  <wiz-group width="100%" height="100%">
    <!-- lorsque rien n'est sélectionné -->
    <wiz-vgroup width="100%" *ngIf="!showDetail" class="section-container-parent">
      <widget-renderer class="view-widget" width="100%" [title]="'$.user.home.title.$'"
        [description]="'$.user.home.description.$'"></widget-renderer>
    </wiz-vgroup>

    <wiz-vgroup #vgDetailZone [visible]="showDetail" width="100%" height="100%" class="section-container-parent"
      gap="10">
      <wiz-hgroup padding="10px" width="100%" class="section-container" horizontalAlign="space-between">
        <wiz-vgroup wizValidationContainer verticalAlign="center">
          <!-- champ de saisi -->
          <wiz-hgroup gap="20" wizValidationContainer>
            <wiz-text-input #tiFname wizValidator width="205px" [wizLabel]="'$.user.firstname.$'" [wizShowErrors]="true"
              [wizMandatory]="true" [wizMaxChars]="50" [wizPlaceholder]="'$.common.define.$'" [wizDisabled]="true">
            </wiz-text-input>

            <wiz-text-input #tiLname wizValidator width="205px" [wizLabel]="'$.user.lastname.$'" [wizMandatory]="true"
              [wizShowErrors]="true" [wizPlaceholder]="'$.common.define.$'" [wizMaxChars]="50" [wizShowErrors]="true"
              [wizDisabled]="true">
            </wiz-text-input>
            <wiz-checkbox #chbLock [wizLabel]="'$.common.locked.$'" [wizDisabled]="true"></wiz-checkbox>
          </wiz-hgroup>
        </wiz-vgroup>
        <!-- bouton d'action -->
        <wiz-vgroup gap="0" padding="3px">
          <wiz-button #btnSave [wizIcon]="'arrow-right'" [wizLabel]="'$.common.save.modification.$'"
            [iconPlacement]="'right'"></wiz-button>
          <wiz-button #btnCancel class="cancel-button" [wizIcon]="'arrow-left'"
            [wizLabel]="'$.common.cancel.modification.$'"></wiz-button>
        </wiz-vgroup>
      </wiz-hgroup>

      <wiz-hgroup width="100%" height="100%" class="section-container" padding="10px" gap="0">
        <wiz-vgroup height="100%" minWidth="600px" width="100%">
          <wiz-label [wizLabel]="'$.user.role.available.$'" class="smallTitleLabel"></wiz-label>
          <!-- liste des roles disponibles -->
          <wiz-ag-grid #agGrid id="agGrid" width="100%" height="100%" class="ag-theme-alpine"
            [gridOptions]="gridOptions"
            [wizDatasource]="rolesByFeature" [columnDefs]="availableRolesColumns"
            [frameworkComponents]="availableRolesRenderer" [tooltipShowDelay]="0"
            (cellClicked)="onPermissionCellClicked($event)"
            (wizCellEdit)="onCellEdit($event)">
          </wiz-ag-grid>
          <filter-component #availableRolesFilter> </filter-component>
        </wiz-vgroup>
      </wiz-hgroup>
    </wiz-vgroup>
  </wiz-group>
</wiz-h-divider>